export default "__VITE_ASSET__23d539d9__"